import { createElectronPlatform } from './electron-platform'
import type { IPlatform } from './types'
import { webPlatform } from './web-platform'

function detectPlatform(): IPlatform {
  if (typeof window !== 'undefined' && window.edge?.kind === 'electron') {
    return createElectronPlatform(window.edge)
  }
  return webPlatform
}

/**
 * Singleton platform instance. Detected once at module-eval. The native
 * bridge is injected by the preload script, which runs before app code,
 * so detection at module-eval time is safe.
 */
export const platform: IPlatform = detectPlatform()

export type { IPlatform, SecureStore, NativeBridge } from './types'
